<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col cols="12" md="12">
                <component-header
                    title="Create FAQ"
                    :hasSearch="false"
                    :hasCreate="false"
                    :hasReload="false"
                    :hasback="true"
                    @back-press="$router.push({ name: 'Faqs' })"
                />
            </b-col>
            <b-col cols="12" md="12">
                <b-card
                    ><ValidationObserver v-slot="{ invalid }" ref="observer">
                        <b-row v-if="$userRole === 'Tenant'" class="form-row">
                            <b-col
                                cols="12"
                                sm="12"
                                md="4"
                                class="mb-3 mb-md-0"
                            >
                                <span class="form-label">Scope</span>
                            </b-col>
                            <b-col
                                cols="12"
                                sm="12"
                                md="8"
                                class="mb-3 mb-md-0"
                            >
                                <ValidationProvider
                                    rules="required"
                                    v-slot="{ errors }"
                                    name="scope"
                                >
                                    <eb-select
                                        type="text"
                                        v-model="scope"
                                        :options="scopeOptions"
                                        label="label"
                                        placeholder="Select scope"
                                    ></eb-select>
                                    <span class="validate-error">{{
                                        errors[0]
                                    }}</span>
                                </ValidationProvider>
                            </b-col>
                        </b-row>
                        <b-row class="form-row">
                            <b-col
                                cols="12"
                                sm="12"
                                md="4"
                                class="mb-3 mb-md-0"
                            >
                                <span class="form-label">Category</span>
                            </b-col>
                            <b-col
                                cols="12"
                                sm="12"
                                md="8"
                                class="mb-3 mb-md-0"
                            >
                                <ValidationProvider
                                    rules="required"
                                    v-slot="{ errors }"
                                    name="category"
                                >
                                    <eb-select
                                        type="text"
                                        v-model="category"
                                        :options="categoryOptions"
                                        label="label"
                                        placeholder="Select category"
                                    ></eb-select>
                                    <span class="validate-error">{{
                                        errors[0]
                                    }}</span>
                                </ValidationProvider>
                            </b-col>
                        </b-row>
                        <b-row class="form-row">
                            <b-col
                                cols="12"
                                sm="12"
                                md="4"
                                class="mb-3 mb-md-0"
                            >
                                <span class="form-label">Topic</span>
                            </b-col>
                            <b-col
                                cols="12"
                                sm="12"
                                md="8"
                                class="mb-3 mb-md-0"
                            >
                                <div class="form-group">
                                    <ValidationProvider
                                        rules="required"
                                        v-slot="{ errors }"
                                        name="topic"
                                    >
                                        <b-form-input
                                            class="custom-transform-class"
                                            inputType="text"
                                            placeholder="Topic"
                                            v-model="topic"
                                        />
                                        <span class="validate-error">{{
                                            errors[0]
                                        }}</span>
                                    </ValidationProvider>
                                </div>
                            </b-col>
                        </b-row>

                        <b-row class="form-row">
                            <b-col
                                cols="12"
                                sm="12"
                                md="4"
                                class="mb-3 mb-md-0"
                            >
                                <span class="form-label">Description</span>
                            </b-col>
                            <b-col
                                cols="12"
                                sm="12"
                                md="8"
                                class="mb-3 mb-md-0"
                            >
                                <div class="form-group">
                                    <ValidationProvider
                                        rules="required"
                                        v-slot="{ errors }"
                                        name="description"
                                    >
                                        <b-form-textarea
                                            v-model="description"
                                            placeholder="Enter something..."
                                            rows="3"
                                            max-rows="6"
                                        ></b-form-textarea>
                                        <span class="validate-error">{{
                                            errors[0]
                                        }}</span>
                                    </ValidationProvider>
                                </div>
                            </b-col>
                        </b-row>
                        <b-row class="form-row">
                            <b-col
                                cols="12"
                                sm="12"
                                md="4"
                                class="mb-3 mb-md-0"
                            >
                                <span class="form-label">Media Type</span>
                            </b-col>
                            <b-col
                                cols="12"
                                sm="12"
                                md="8"
                                class="mb-3 mb-md-0"
                            >
                                <ValidationProvider
                                    rules="required"
                                    v-slot="{ errors }"
                                    name="Media Type"
                                >
                                    <eb-select
                                        type="text"
                                        v-model="mediatype"
                                        :options="mediaOptions"
                                        label="label"
                                        @select="onSelect"
                                        placeholder="Select Media Type"
                                    ></eb-select>
                                    <span class="validate-error">{{
                                        errors[0]
                                    }}</span>
                                </ValidationProvider>
                            </b-col>
                        </b-row>
                        <b-row
                            v-if="
                                mediatype == 'VIDEO' ||
                                mediatype == 'IMAGE' ||
                                mediatype == 'DOCUMENT'
                            "
                            class="form-row"
                        >
                            <b-col
                                cols="12"
                                sm="12"
                                md="4"
                                class="mb-3 mb-md-0"
                            >
                                <span class="form-label">Upload Media</span>
                            </b-col>
                            <b-col
                                cols="12"
                                sm="12"
                                md="7"
                                class="mb-3 mb-md-0"
                            >
                                <ValidationProvider
                                    rules="required"
                                    v-slot="{ errors, validate }"
                                    name="Media"
                                >
                                    <b-form-file
                                        id="filePicker"
                                        @change="validate"
                                        v-on:change="changePhoto"
                                        :state="Boolean()"
                                        :accept="uploadFileType"
                                        placeholder="Choose a Media..."
                                        drop-placeholder="Drop Media here..."
                                    ></b-form-file>
                                    <span class="validate-error">{{
                                        errors[0]
                                    }}</span>
                                </ValidationProvider>
                            </b-col>
                            <b-col
                                cols="12"
                                sm="12"
                                md="1"
                                v-if="showLoader"
                                class="mb-3 mb-md-0"
                            >
                                <div
                                    class="spinner-border text-primary"
                                    role="status"
                                ></div>
                            </b-col>
                        </b-row>
                        <span v-if="invalidFile" class="validate-error"
                            >Invalid File format</span
                        >
                        <hr />
                        <div class="text-center mt-3 mb-3">
                            <eb-button
                                class="btn mr-4 fixed-width-btn"
                                classic="mr-1 btn-primary"
                                text="Save"
                                :disabled="invalid || invalidFile || showLoader"
                                @click.prevent="handleSubmit"
                            ></eb-button>
                        </div>
                    </ValidationObserver>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import ebSelect from "@/components/FormElements/Select.vue";
import ebButton from "@/components/FormElements/Button";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import ComponentHeader from "@/components/componentNewHeader";
import currentUser from "@/mixins/currentUser";

export default {
    name: "createfaq",
    mixins: [currentUser],
    components: {
        ebButton,
        ebSelect,
        ValidationObserver,
        ValidationProvider,
        ComponentHeader,
    },

    data: () => {
        return {
            show: true,
            mediatype: "",
            photo: "",
            scope: "",
            mediaOptions: ["VIDEO", "IMAGE", "DOCUMENT"],
            categoryOptions: ["Order", "Payment", "CASHBACK"],
            scopeOptions: ["PARTNER", "CUSTOMER"],
            category: "",
            showLoader: false,
            invalidFile: false,
            topic: "",
            description: "",
        };
    },
    computed: {
        uploadFileType() {
            if (this.mediatype == "IMAGE") return "image/*";
            if (this.mediatype == "VIDEO") return "video/*";
            return "text/*,application/*";
        },
    },
    methods: {
        generateUniqueKey() {
            return (
                Date.now().toString(36) +
                Math.random().toString(36).substr(2, 5)
            ).toLowerCase();
        },
        buildUploadConfig() {
            return {
                key: this.generateUniqueKey(),
                isPublic: true,
                replaceExisting: true,
                basePath: "faq",
            };
        },
        buildFormDataPayload(file) {
            const formData = new FormData();
            const config = this.buildUploadConfig();
            formData.append("file", file);
            formData.append("isPublic", config.isPublic.toString());
            formData.append("replaceExisting", config.replaceExisting.toString());
            formData.append("basePath", config.basePath);
            formData.append("key", config.key);
            return formData;
        },
        buildImagePayload(dataUrl) {
            return {
                image: dataUrl,
                ...this.buildUploadConfig(),
            };
        },
        onSelect() {
            // Media type selection handler
        },
        async uploadMedia(file) {
            this.$toasted.info("Uploading...");
            this.showLoader = true;
            try {
                if (this.mediatype === "IMAGE") {
                    const dataUrl = await this.readFileAsDataUrl(file);
                    const payload = this.buildImagePayload(dataUrl);
                    const res = await this.$store.dispatch(
                        "inventory/uploadImageToStorage",
                        payload,
                    );
                    this.photo = res.data.fileUrl;
                } else {
                    const formData = this.buildFormDataPayload(file);
                    const res = await this.$store.dispatch(
                        "inventory/uploadVideoToStorage",
                        formData,
                    );
                    this.photo = res.data.fileUrl;
                }
                this.$toasted.success("Upload Complete");
            } catch (error) {
                console.error("File upload error:", error);
            } finally {
                this.showLoader = false;
            }
        },
        readFileAsDataUrl(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = () => resolve(reader.result);
                reader.onerror = (err) => reject(err);
                reader.readAsDataURL(file);
            });
        },
        validateFileType(file) {
            if (this.mediatype === "IMAGE") return file.type.match("image.*");
            if (this.mediatype === "VIDEO") return file.type.match("video.*");
            if (this.mediatype === "DOCUMENT") {
                return (
                    file.type.match("application.*") ||
                    file.type.match("text.*")
                );
            }
            return false;
        },
        changePhoto(e) {
            const file = e.target.files[0];
            if (!file) return;

            if (!this.validateFileType(file)) {
                this.invalidFile = true;
                e.target.value = "";
                return;
            }
            this.invalidFile = false;
            this.uploadMedia(file);
        },
        async handleSubmit() {
            const isValid = await this.$refs.observer.validate();
            if (!isValid) return;
            let dataObj;
            if (this.$userRole === "Tenant") {
                dataObj = {
                    category: this.category,
                    scope: this.scope,
                    item: {
                        topic: this.topic,
                        description: this.description,
                        media: {
                            mediaType: this.mediatype,
                            mediaContent: this.photo,
                        },
                    },
                };
            } else {
                dataObj = {
                    category: this.category,
                    scope: "TENANT",
                    item: {
                        topic: this.topic,
                        description: this.description,
                        media: {
                            mediaType: this.mediatype,
                            mediaContent: this.photo,
                        },
                    },
                };
            }
            await this.$store.dispatch("faq/createFaq", dataObj).then(() => {
                this.$swal({
                    title: "Success",
                    text: "Faq added successfully!!",
                    type: "success",
                });
                this.$router.push({ name: "Faqs" });
            });
        },
    },
    watch: {
        mediatype(newval, oldval) {
            if (newval != oldval) {
                if (this.photo != "") this.invalidFile = true;
                this.photo = "";
            }
        },
    },
};
</script>
<style scoped>
.form-row {
    margin-bottom: 1rem;
}

.form-label {
    display: block;
    margin-bottom: 0.5rem;
    font-weight: 500;
}

.validate-error {
    display: block;
    color: red;
    font-size: 12px;
    margin-top: 5px;
}

.fa-plus {
    border-top-right-radius: 10px;
    border-top-left-radius: 17px;
    border-bottom-left-radius: 17px;
    background-color: #f0f3f5;
}

.fixed-width-btn {
    width: 100px;
    font-size: 15px;
}

@media (max-width: 767.98px) {
    .form-label {
        margin-bottom: 0.25rem;
        font-size: 0.9rem;
    }

    .fixed-width-btn {
        width: 100%;
    }
}
</style>
